import { roles } from '@nxsys/store/constants';

// The role the app gates on, from the backend's `roles`. NX-5877: a value not
// listed here gets no role, so no route, menu or notification feed. It used
// to get admin.
export const roleOf = (user?: { roles?: string } | null) => {
  switch (user?.roles) {
    case 'admin':
      return roles.admin;
    case 'super_admin':
      return roles.supper_admin;
    case 'company':
      return roles.employer;
    case 'subcontractor':
      return roles.employee;
    case 'agency':
      return roles.agency;
    default:
      return undefined;
  }
};

// Who reads the tenant-wide notifications: the admin feed, its mark-all-read
// and the tenant's two live channels. Every place that decides it asks here.
export const hasTenantFeed = (role?: string) =>
  role === roles.admin || role === roles.supper_admin;
